module.exports = __webpack_public_path__ + "static/media/location.17fd62bd.svg";